import { useEffect } from "react";

import { useToast } from "./Toast";

export const ViewOnlyModeToastBridge = () => {
  const { error } = useToast();

  useEffect(() => {
    window.onViewOnlyModeError = error;
    return () => {
      window.onViewOnlyModeError = undefined;
    };
  }, [error]);

  return null;
};
